import { render, staticRenderFns } from "./distributed-columns-cargos.vue?vue&type=template&id=58c9d03b&scoped=true"
import script from "./distributed-columns-cargos.vue?vue&type=script&lang=js"
export * from "./distributed-columns-cargos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58c9d03b",
  null
  
)

export default component.exports